import React from 'react';

const SalesChart = ({ data }) => {
    if (!data || data.length === 0) {
        return (
            <div className="rounded-xl bg-white p-6 shadow-lg">
                <h3 className="mb-6 text-lg font-bold text-gray-800">Détail des Ventes par Produit</h3>
                <div className="flex h-64 items-center justify-center text-gray-500">
                    Pas de données de vente disponibles
                </div>
            </div>
        );
    }

    const maxQuantity = Math.max(...data.map(d => d.quantity));

    return (
        <div className="rounded-xl bg-white p-6 shadow-lg">
            <h3 className="mb-6 text-lg font-bold text-gray-800">Détail des Ventes par Produit</h3>
            <div className="flex flex-col gap-4">
                {data.map((item, index) => {
                    const widthPercentage = maxQuantity > 0 ? (item.quantity / maxQuantity) * 100 : 0;
                    return (
                        <div key={index} className="flex flex-col gap-1">
                            <div className="flex justify-between text-sm font-medium text-gray-700">
                                <span>{item.name}</span>
                                <span className="font-bold">{item.quantity} vendus</span>
                            </div>
                            <div className="h-4 w-full overflow-hidden rounded-full bg-gray-100">
                                <div
                                    className="h-full rounded-full bg-gradient-to-r from-blue-500 to-blue-400 transition-all duration-1000 ease-out"
                                    style={{ width: `${widthPercentage}%` }}
                                />
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default SalesChart;
